import { Dayjs } from 'dayjs';

/**
 * Format a timestamp as ISO-8601 in UTC **without milliseconds** (second precision).
 *
 * Example: 2025-07-01T12:03:02.515Z -> 2025-07-01T12:03:02
 */
export function toISOStringNoMs(t: Dayjs | Date): string {
  const iso = t instanceof Date ? t.toISOString() : t.toDate().toISOString();
  // Drop milliseconds and trailing 'Z' (URLs should not include ms or Z).
  return iso.replace(/\.\d{3}Z$/, '').replace(/Z$/, '');
}


